<!-- drawer component -->
<div
  id="drawer-navigation"
  class="fixed top-0 z-50 flex flex-1 flex-col justify-evenly w-full sm:w-[18rem] h-screen whitespace-nowrap transition-transform bg-white dark:bg-gray-800 scrollbar-custom"
  [ngClass]="{
    'left-0 -translate-x-full': !isRTL,
    'right-0 translate-x-full': isRTL,
  }"
  tabindex="-1"
  aria-labelledby="drawer-navigation-label"
>
  <div class="px-4 py-2.5 flex items-center">
    <button
      name="sidebarButton"
      type="button"
      data-drawer-hide="drawer-navigation"
      aria-controls="drawer-navigation"
      class="text-gray-400 bg-transparent hover:bg-gray-200 hover:text-secondary rounded-lg text-sm p-1.5 inline-flex items-center dark:hover:bg-gray-600 dark:hover:text-white"
    >
      <svg
        class="w-[35px] h-[35px] text-secondary dark:text-white"
        aria-hidden="true"
        xmlns="http://www.w3.org/2000/svg"
        fill="none"
        viewBox="0 0 24 24"
      >
        <path
          stroke="currentColor"
          stroke-linecap="round"
          stroke-width="2"
          d="M5 7h14M5 12h14M5 17h10"
        />
      </svg>
    </button>
    <a
      href="#"
      class="flex items-center ml-4 cursor-pointer"
      data-drawer-hide="drawer-navigation"
      aria-controls="drawer-navigation"
    >
      <img
        width="120px"
        loading="lazy"
        src="../../../assets/logo.png"
        alt="Dashy logo"
      />
    </a>
  </div>

  <div class="px-4 h-full overflow-y-auto">
    <ul class="space-y-2 font-normal">
      <li *ngFor="let menu of allMenus">
        <a
          *ngIf="menu.items === undefined && isUserAuthorized(menu)"
          data-drawer-hide="drawer-navigation"
          aria-controls="drawer-navigation"
          [routerLinkActive]="['border-l-4', 'border-accent', 'bg-gray-200']"
          [routerLink]="menu.path"
          [queryParams]="menu.queryParams || {}"
          class="flex items-center p-2 text-base text-secondary dark:text-white hover:bg-gray-100 dark:hover:bg-gray-700 group"
        >
          <i
            [ngClass]="menu.icon"
            class="fa-lg fa-fw mr-3 text-secondary transition dark:text-gray-400 group-hover:text-primary dark:group-hover:text-white"
            [class.ml-3]="isRTL"
          ></i>
          <span class="max-w-md break-words whitespace-normal">{{
            menu.label! | translate
          }}</span>
        </a>
        <div
          *ngIf="menu.items && menu.items.length > 0 && isUserAuthorized(menu)"
        >
          <button
            (click)="toggleSubItems(menu.path)"
            type="button"
            class="flex items-center w-full p-2 text-base text-secondary transition duration-75 group hover:bg-gray-100 dark:text-white dark:hover:bg-gray-700"
          >
            <i
              [ngClass]="menu.icon"
              class="mr-3 fa-lg fa-fw text-secondary transition dark:text-gray-400 group-hover:text-primary dark:group-hover:text-white"
              [class.ml-3]="isRTL"
            ></i>
            <span
              class="flex-1 text-left rtl:text-right max-w-md break-words whitespace-normal"
              >{{ menu.label! | translate }}</span
            >

            <!-- Down Arrow when submenu is closed -->
            <svg
              *ngIf="!showSubItems || menu.path !== currentPathSubItems"
              class="w-3 h-3"
              aria-hidden="true"
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 10 6"
            >
              <path
                stroke="currentColor"
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="2"
                d="m1 1 4 4 4-4"
              />
            </svg>

            <!-- Up Arrow when submenu is open -->
            <svg
              *ngIf="showSubItems && menu.path === currentPathSubItems"
              class="w-3 h-3"
              aria-hidden="true"
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 10 6"
            >
              <path
                stroke="currentColor"
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="2"
                d="m1 5 4-4 4 4"
              />
            </svg>
          </button>

          <ul
            id="dropdown"
            *ngIf="showSubItems && menu?.path === currentPathSubItems"
            class="space-y-2 pl-5 py-2"
          >
            <li *ngFor="let submenu of menu.items">
              <a
                *ngIf="isUserInRole(submenu.authorities)"
                data-drawer-hide="drawer-navigation"
                aria-controls="drawer-navigation"
                [routerLinkActive]="[
                  'border-l-4',
                  'border-accent',
                  'bg-gray-200',
                ]"
                [routerLinkActiveOptions]="{ exact: true }"
                [routerLink]="submenu.path"
                [queryParams]="submenu.queryParams || {}"
                (click)="onSubmenuClick()"
                class="flex items-center p-2 text-secondary transition duration-75 group hover:bg-gray-100 dark:text-white dark:hover:bg-gray-700"
              >
                <i
                  [ngClass]="submenu.icon"
                  class="fa-fw mr-3 text-secondary transition dark:text-gray-400 group-hover:text-primary dark:group-hover:text-white"
                  [class.ml-3]="isRTL"
                ></i>
                <span class="whitespace-nowrap">{{
                  submenu.label | translate
                }}</span>
              </a>
            </li>
          </ul>
        </div>
      </li>
    </ul>
  </div>

  <div
    *ngIf="profile && profile.username"
    class="flex justify-between p-3 border border-t w-full bg-white"
  >
    <a
      routerLink="/profile/my-profile"
      class="flex items-center w-full overflow-hidden cursor-pointer"
      data-drawer-hide="drawer-navigation"
      aria-controls="drawer-navigation"
    >
      <div class="flex-shrink-0">
        <div
          class="relative inline-flex items-center justify-center w-9 h-9 bg-accent rounded-full"
        >
          <span class="font-normal text-white">
            {{ profile.username[0].toUpperCase() }}
          </span>
        </div>
      </div>
      <div class="ms-2 flex-1 min-w-0 overflow-hidden">
        <p
          class="text-sm font-normal text-secondary truncate dark:text-white"
          title="{{ profile.firstName }} {{ profile.lastName }}"
        >
          {{ profile.firstName }} {{ profile.lastName }}
        </p>
        <p class="text-xs text-gray-500 truncate" title="{{ profile.email }}">
          {{ profile.email }}
        </p>
      </div>
    </a>
    <div
      class="inline-flex items-center text-base font-semibold text-secondary dark:text-white"
    >
      <button
        (click)="signout()"
        matTooltip="{{ 'APP_USER.LOGOUT' | translate }}"
        [matTooltipPosition]="'after'"
        type="button"
        class="text-secondary bg-transparent hover:text-primary text-sm p-1.5 inline-flex items-center dark:hover:bg-gray-600 dark:hover:text-white"
      >
        <i class="fa-solid fa-right-from-bracket text-xl"></i>
      </button>
    </div>
  </div>
</div>
